"use strict";

require("core-js/modules/es.symbol");

require("core-js/modules/es.symbol.description");

require("core-js/modules/es.symbol.iterator");

require("core-js/modules/es.array.from");

require("core-js/modules/es.array.index-of");

require("core-js/modules/es.array.iterator");

require("core-js/modules/es.array.map");

require("core-js/modules/es.array.slice");

require("core-js/modules/es.function.name");

require("core-js/modules/es.number.constructor");

require("core-js/modules/es.object.assign");

require("core-js/modules/es.object.get-prototype-of");

require("core-js/modules/es.object.keys");

require("core-js/modules/es.object.to-string");

require("core-js/modules/es.reflect.construct");

require("core-js/modules/es.regexp.to-string");

require("core-js/modules/es.string.iterator");

require("core-js/modules/web.dom-collections.iterator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Control = _interopRequireDefault(require("../../elements/Control"));

var _mapToCssModules = _interopRequireDefault(require("../../utils/mapToCssModules"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Score = /*#__PURE__*/function (_React$Component) {
  _inherits(Score, _React$Component);

  var _super = _createSuper(Score);

  function Score(props) {
    var _this;

    _classCallCheck(this, Score);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "handleScoreChange", function (scoreIndex) {
      var onChange = _this.props.onChange;

      _this.setState({
        activeItem: scoreIndex
      });

      onChange(Number(scoreIndex));
    });

    _defineProperty(_assertThisInitialized(_this), "handleKeyDown", function (e) {
      if (e.key === 'Enter') {
        _this.handleScoreChange(Number(e.target.textContent));
      }
    });

    _defineProperty(_assertThisInitialized(_this), "renderScores", function (maxScore) {
      var activeItem = _this.state.activeItem;
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, _toConsumableArray(Array(maxScore + 1)).map(function (scoreVal, i) {
        return /*#__PURE__*/_react.default.createElement("span", {
          tabIndex: "0",
          id: "score-input__scoreVal--".concat(i),
          role: "button",
          className: activeItem === i ? 'score-input__scoreVal activeCustom' : 'score-input__scoreVal',
          onKeyDown: _this.handleKeyDown,
          onClick: _this.handleScoreChange.bind(_assertThisInitialized(_this), i),
          key: i
        }, i);
      }));
    });

    _this.state = {
      activeItem: -1
    };
    return _this;
  }

  _createClass(Score, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          id = _this$props.id,
          name = _this$props.name,
          isInline = _this$props.isInline,
          cssModule = _this$props.cssModule,
          required = _this$props.required,
          requiredText = _this$props.requiredText,
          label = _this$props.label,
          labelProps = _this$props.labelProps,
          tooltip = _this$props.tooltip,
          tooltipProps = _this$props.tooltipProps,
          width = _this$props.width,
          _onChange = _this$props.onChange,
          helpText = _this$props.helpText,
          error = _this$props.error,
          status = _this$props.status,
          statusMessage = _this$props.statusMessage,
          maxScore = _this$props.maxScore,
          startLabel = _this$props.startLabel,
          endLabel = _this$props.endLabel,
          attrs = _objectWithoutProperties(_this$props, ["className", "id", "name", "isInline", "cssModule", "required", "requiredText", "label", "labelProps", "tooltip", "tooltipProps", "width", "onChange", "helpText", "error", "status", "statusMessage", "maxScore", "startLabel", "endLabel"]);

      var _status = status;
      var _statusMessage = statusMessage;

      if (error) {
        _status = 'error';
        _statusMessage = error;
      }

      var inputClasses = (0, _mapToCssModules.default)((0, _classnames.default)('score-input', _defineProperty({}, "score-input--".concat(_status), !!_status)), cssModule);
      var inputId = id || name;
      return /*#__PURE__*/_react.default.createElement(_Control.default, {
        name: inputId,
        id: inputId,
        isInline: isInline,
        label: label,
        labelProps: labelProps,
        tooltip: tooltip,
        tooltipProps: tooltipProps,
        helpText: helpText,
        required: required,
        requiredText: requiredText,
        status: _status,
        width: width,
        statusMessage: _statusMessage,
        className: className
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "score-input-wrapper"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "score-input-labels"
      }, /*#__PURE__*/_react.default.createElement("span", null, startLabel), /*#__PURE__*/_react.default.createElement("span", null, endLabel)), /*#__PURE__*/_react.default.createElement("div", _extends({
        className: inputClasses
      }, attrs), this.renderScores(maxScore))));
    }
  }]);

  return Score;
}(_react.default.Component);

Score.defaultProps = {
  className: undefined,
  isInline: false,
  id: undefined,
  cssModule: undefined,
  required: false,
  requiredText: undefined,
  label: undefined,
  labelProps: {},
  width: undefined,
  tooltip: undefined,
  tooltipProps: {},
  helpText: undefined,
  onChange: function onChange() {},
  error: undefined,
  status: undefined,
  statusMessage: undefined,
  maxScore: 10,
  startLabel: '0 - VERY DIFFICULT',
  endLabel: '10 - VERY EASY'
};
Score.propTypes = {
  /**
   * A description of the prop, it will automatically appear in the docs
   */
  className: _propTypes.default.string,

  /**
   * name will be used as the input's id if it's not provided.
   */
  id: _propTypes.default.string,

  /**
   * The name of the input, will also be used as the id.
   */
  name: _propTypes.default.string.isRequired,

  /**
   * The label of the control.
   */
  label: _propTypes.default.node,

  /**
   * Props to be passed to the label
   */
  labelProps: _propTypes.default.object,

  /**
   * The content of the controls tooltip.
   */
  tooltip: _propTypes.default.node,

  /**
   * Props to be passed to the tooltip
   */
  tooltipProps: _propTypes.default.object,

  /**
   * Help text to display below the field.
   */
  helpText: _propTypes.default.node,

  /**
   * If true, the control will use an inline layout. See `isHorizontal` to adjust the layout of the actual options.
   */
  isInline: _propTypes.default.bool,

  /**
   * If true, the options will be layed out horizontally. See `isInline` to adjust the layout of the controls label.
   */
  error: _propTypes.default.node,
  status: _propTypes.default.oneOf(['error', 'warning', 'info', 'success']),
  statusMessage: _propTypes.default.node,
  required: _propTypes.default.bool,
  requiredText: _propTypes.default.func,
  width: _propTypes.default.oneOf(['xl', 'l', 'm', 's', 'xs', 'xxs']),
  cssModule: _propTypes.default.object,
  onChange: _propTypes.default.func,

  /**
   * Render prop for option item
   */
  maxScore: _propTypes.default.number,
  startLabel: _propTypes.default.string,
  endLabel: _propTypes.default.string
};
var _default = Score;
exports.default = _default;
//# sourceMappingURL=Score.js.map